import './SiteSearch.scss';

import classnames from 'classnames';
import { useOutsideClick } from 'helpers/hooks';
import React, { useCallback, useRef, useState } from 'react';

import SearchFormWrapper from './components/search-form-wrapper/SearchFormWrapper';

const SiteSearch = () => {
  const [showSearch, setShowSearch] = useState(false);

  const wrapperRef = useRef(null);

  const toggleSearch = useCallback(e => {
    if (e) {
      e.preventDefault();
    }
    setShowSearch(current => !current);
  }, []);

  const hideSearch = useCallback(() => {
    setShowSearch(false);
  }, []);

  useOutsideClick(wrapperRef, hideSearch);

  return (
    <div
      ref={wrapperRef}
      className={classnames('site-search', { shown: showSearch })}
    >
      <i className="icon search-icon" onClick={toggleSearch}></i>
      <SearchFormWrapper toggleSearch={toggleSearch} onSubmit={hideSearch} />
    </div>
  );
};

export default SiteSearch;
